var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finished)?_c('div',{staticClass:"timer"},[_c('a',{on:{"click":function($event){$event.preventDefault();_vm.finished = !_vm.finished}}},[_vm._v("ارسال مجدد")])]):_c('div',{staticClass:"timer"},[_vm._v(" "+_vm._s(_vm.display)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }